import { PlacesQueryDocument } from "@pathwright/graphql-client/src/generated"

export default PlacesQueryDocument
